import { useRepositoryMutation, ExportTypeEnum } from '@mews-commander/data-access';
import { downloadFile } from '@mews-commander/utils';
import { useCurrentEnterpriseId } from '@mews-commander/core';

export interface ExportDownloadParams {
    exportId: string;
    exportType: ExportTypeEnum;
}

export const useExportDownload = () => {
    const enterpriseId = useCurrentEnterpriseId();
    return useRepositoryMutation('exports', 'download', {
        transformParams: (param: ExportDownloadParams) => ({
            enterpriseId,
            exportId: param.exportId,
            exportType: param.exportType,
        }),
        onSuccess: (data) => {
            downloadFile(data);
        },
    });
};
